// extracted by css-extract-rspack-plugin
export default {"label":"label-3VogL","secondary":"secondary-3NWvt"};